import { jwtDecode } from 'jwt-decode';

/**
 * Decodifica o token JWT e extrai o campo de admin de forma resiliente
 * Suporta variações de claims: isAdmin, IsAdmin, is_admin, roles, role
 * @param {string} token
 * @returns {boolean}
 */
export const getIsAdminFromToken = (token) => {
  try {
    if (!token) return false;

    // Remove prefixo 'Bearer ' se existir
    if (typeof token === 'string' && token.toLowerCase().startsWith('bearer ')) {
      token = token.slice(7).trim();
    }

    const decoded = jwtDecode(token);

    // Expiração
    if (decoded?.exp && decoded.exp * 1000 < Date.now()) {
      return false;
    }

    const truthy = (v) => {
      if (typeof v === 'boolean') return v;
      if (typeof v === 'number') return v === 1;
      if (typeof v === 'string') return ['true', '1', 'yes', 'y'].includes(v.toLowerCase());
      return false;
    };

    const hasAdminRole = (v) => {
      if (!v) return false;
      if (Array.isArray(v)) return v.map(String).some((s) => s.toLowerCase().includes('admin'));
      return String(v).toLowerCase().includes('admin');
    };

    // 1) Claims comuns explícitas (inclui erro de grafia IsAdmim)
    const directBool =
      decoded?.isAdmin ?? decoded?.IsAdmin ?? decoded?.is_admin ?? decoded?.isadmin ?? decoded?.IsAdmim ?? decoded?.isAdmim;
    if (truthy(directBool)) return true;

    // 2) Roles comuns (role, roles, namespaced claims)
    if (hasAdminRole(decoded?.role ?? decoded?.Role)) return true;
    if (hasAdminRole(decoded?.roles ?? decoded?.Roles)) return true;

    // Namespaced role claims (ex: Microsoft identity)
    const roleLikeKeys = Object.keys(decoded || {}).filter((k) => k.toLowerCase().includes('role'));
    for (const k of roleLikeKeys) {
      if (hasAdminRole(decoded[k])) return true;
    }

    // 3) Busca recursiva por IsAdmin dentro de objetos aninhados (ex: User.IsAdmin)
    const stack = [decoded];
    while (stack.length) {
      const cur = stack.pop();
      if (cur && typeof cur === 'object') {
        for (const [k, v] of Object.entries(cur)) {
          const key = k.toLowerCase();
          if (['isadmin', 'isadmim', 'is_admin'].includes(key) && truthy(v)) return true;
          if (v && typeof v === 'object') stack.push(v);
        }
      }
    }

    return false;
  } catch (error) {
    return false;
  }
};
